import Home from '@/views/index'
import About from '@/views/about'
import Contact from '@/views/contact'
import Details from '@/views/details'

//配置文件

import { createRouter, createWebHistory } from 'vue-router'
const routerHistory = createWebHistory()
const routes=[
  {
    path:'/',
    redirect:"/home",
  },
  {
    path:'/home',
    name:'home',
    component:Home
  },
  {
    path:'/about',
    name:'about',
    component:About
  },
  {
    path:'/contact',
    name:'contact',
    component:Contact
  },
  {
    path:'/identity',
    name:'identity',
    component: Details
  },
  {
    path:'/education',
    name:'education',
    component: Details
  },
  {
    path:'/enterprise',
    name:'enterprise',
    component: Details
  },
  {
    path:'/invest',
    name:'invest',
    component: Details
  },
  {
    path:'/medical',
    name:'medical',
    component: Details
  },
]

const router = createRouter({
  history: routerHistory,
  routes
})
export default router